import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISTDBoxes_Details_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISTDBoxes_Details_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  SelectSTDBoxes: any[];
  SelectSTDBoxes_dummy: any[];
  SelectStdproductsForProductid: any[];
  SelectStdproductsForProductid_dummy: any[];
  SelectStdstationsForStationid: any[];
  SelectStdstationsForStationid_dummy: any[];
  GetStationInfo: any[];
  GetStationInfo_dummy: any[];
  GetProductDetail: any[];
  GetProductDetail_dummy: any[];
  isComp238713Enabled: "enabled" | "disabled";
  isComp756585Enabled: "enabled" | "disabled";
}

export class STDBoxes_Details_ScreenBase extends React.PureComponent<
  ISTDBoxes_Details_ScreenProps,
  any
> {
  stdboxes_details_880268_value_kuikaSelectBoxRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "cd817f94-ccbc-45e7-9ada-96f7d430ce8b",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 428726, PropertyName: "value", Value: "KLT - Kutu  Form" },
        { Id: 280093, PropertyName: "value", Value: "Kutu ID" },
        { Id: 238713, PropertyName: "placeholder", Value: "15" },
        { Id: 199963, PropertyName: "value", Value: "İstasyon" },
        { Id: 606034, PropertyName: "value", Value: "Malzeme " },
        { Id: 880268, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 972129, PropertyName: "value", Value: "Müşteri Malzeme Kodu" },
        { Id: 756585, PropertyName: "placeholder", Value: "15" },
        { Id: 517781, PropertyName: "value", Value: "Müşteri Malzeme Tanımı" },
        { Id: 804937, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 156988, PropertyName: "value", Value: "Kutu Tipi" },
        { Id: 628129, PropertyName: "value", Value: "İçerik Adet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.stdboxes_details_880268_value_kuikaSelectBoxRef = React.createRef();
    this.stdboxes_details_804937_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      SelectSTDBoxes: [],
      SelectStdproductsForProductid: [],
      SelectStdstationsForStationid: [],
      GetStationInfo: [],
      GetProductDetail: [],
      isComp238713Enabled: "disabled",
      isComp756585Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("stdboxes_details", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.STDBoxes_DetailsPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("stdboxes_details", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("stdboxes_details", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.STDBoxes_DetailsPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      stdboxes_details_238713_value:
        this.state.SelectSTDBoxes?.at?.(0)?.boxIdentifier ?? undefined,
      stdboxes_details_880268_value:
        this.state.SelectSTDBoxes?.at?.(0)?.productId ?? undefined,
      stdboxes_details_756585_value:
        this.state.SelectSTDBoxes?.at?.(0)?.customerProductCode ?? undefined,
      stdboxes_details_804937_value:
        this.state.SelectSTDBoxes?.at?.(0)?.customerProductDesc ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  STDBoxes_DetailsPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      Id_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_details_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Details/STDBoxes_DetailsPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectSTDBoxes = result?.data.selectSTDBoxes;
    formVars.stdboxes_details_238713_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].boxIdentifier
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].boxIdentifier
        : null
    );
    formVars.stdboxes_details_880268_value =
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].productId
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].productId
        : null;
    formVars.stdboxes_details_880268_options =
      stateVars.SelectStdproductsForProductid;
    formVars.stdboxes_details_756585_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].customerProductCode
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].customerProductCode
        : null
    );
    formVars.stdboxes_details_804937_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].customerProductDesc
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].customerProductDesc
        : null
    );
    formVars.stdboxes_details_391490_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].boxType
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].boxType
        : null
    );
    formVars.stdboxes_details_367201_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].expectedQuantity
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].expectedQuantity
        : null
    );
    stateVars.isComp238713Enabled =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].id
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp756585Enabled =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].id
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.SelectStdproductsForProductid =
      result?.data.selectStdproductsForProductid;

    formVars.stdboxes_details_880268_value =
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].productId
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].productId
        : null;
    formVars.stdboxes_details_880268_options =
      stateVars.SelectStdproductsForProductid;
    stateVars.SelectStdstationsForStationid =
      result?.data.selectStdstationsForStationid;
    stateVars.GetStationInfo = result?.data.getStationInfo;
    formVars.stdboxes_details_118875_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationInfo !== undefined
        ? stateVars.GetStationInfo?.length > 0
          ? stateVars.GetStationInfo[0].stationName
          : null
        : this.state.GetStationInfo?.length > 0
        ? this.state.GetStationInfo[0].stationName
        : null
    );
    stateVars.GetProductDetail = result?.data.getProductDetail;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDBoxes_DetailsPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_DetailsPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stdboxes_details_238713_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].boxIdentifier
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].boxIdentifier
        : null
    );

    stateVars.isComp238713Enabled =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].id
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    formVars.stdboxes_details_118875_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationInfo !== undefined
        ? stateVars.GetStationInfo?.length > 0
          ? stateVars.GetStationInfo[0].stationName
          : null
        : this.state.GetStationInfo?.length > 0
        ? this.state.GetStationInfo[0].stationName
        : null
    );

    formVars.stdboxes_details_880268_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].productId
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].productId
        : null
    );

    stateVars.dataSource_880268 =
      stateVars.SelectStdproductsForProductid ??
      this.state.SelectStdproductsForProductid;
    stateVars.dataSource_880268 =
      stateVars.SelectStdproductsForProductid ??
      this.state.SelectStdproductsForProductid;
    formVars.stdboxes_details_756585_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].customerProductCode
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].customerProductCode
        : null
    );

    stateVars.isComp756585Enabled =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].id
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    formVars.stdboxes_details_804937_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].customerProductDesc
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].customerProductDesc
        : null
    );

    formVars.stdboxes_details_391490_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].boxType
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].boxType
        : null
    );

    formVars.stdboxes_details_367201_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].expectedQuantity
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].expectedQuantity
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDBoxes_DetailsComponent_968274_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDBoxes_DetailsComponent_880268_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_details_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Details/STDBoxes_DetailsComponent_880268_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProductDetail = result?.data.getProductDetail;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
